import { useLanguage } from "@/lib/LanguageContext";

export default function About() {
    const { t } = useLanguage();
    return (
        <section id="about" className="ps-section ps-relative-z" data-testid="about-section">
            <div className="ps-container">
                <div className="ps-section-head">
                    <h2 className="ps-display ps-section-title" data-split data-split-scroll data-testid="about-title">
                        {t.about.title}
                    </h2>
                </div>
                <div className="ps-about-grid">
                    <p className="ps-about-lead ps-fade" data-testid="about-lead"
                       dangerouslySetInnerHTML={{ __html: t.about.lead }} />
                    <div className="ps-about-body ps-fade" data-testid="about-body">
                        {t.about.body.map((p) => <p key={p}>{p}</p>)}
                        <div className="ps-stats">
                            {t.about.stats.map((s) => (
                                <div key={s.label}>
                                    <div className="ps-stat-num">{s.num}<span style={{fontSize:"1rem"}}>{s.suffix}</span></div>
                                    <div className="ps-stat-label">{s.label}</div>
                                </div>
                            ))}
                        </div>
                    </div>
                </div>
            </div>
        </section>
    );
}
